import { call, put } from "redux-saga/effects";
import { instructorCourseApi } from "@services/api";
import { createDiscountActions, getDiscountsActions } from "../slices";

function* createDiscountWorker({ payload }) {
  try {
    yield put(createDiscountActions.pending());
    const response = yield call(
      instructorCourseApi.createDiscount,
      payload.data
    );
    yield put(createDiscountActions.success(response));

    yield put(getDiscountsActions.pending());
    const responseGet = yield call(instructorCourseApi.getDiscounts, payload);
    yield put(getDiscountsActions.success(responseGet));

    payload.resetFormik();
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(createDiscountActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { createDiscountWorker };
